class ProjectSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.project-slider');
    this.prevBtn = root.querySelector('[data-slider-prev]');
    this.nextBtn = root.querySelector('[data-slider-next]');
    this.dotsWrap = root.querySelector('[data-slider-dots]');
    this.slides = this.track ? Array.from(this.track.children) : [];
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (!this.track || this.slides.length === 0) return;

    this.buildDots();
    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.scrollToSlide(i));
      this.dotsWrap.appendChild(dot);
    });
    this.updateDots();
  }

  updateDots() {
    if (!this.dotsWrap) return;
    const index = this.currentIndex();
    Array.from(this.dotsWrap.children).forEach((dot, i) => {
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  currentIndex() {
    const scrollLeft = this.track.scrollLeft;
    let closest = 0;
    let minDiff = Infinity;
    this.slides.forEach((slide, i) => {
      const diff = Math.abs(slide.offsetLeft - scrollLeft);
      if (diff < minDiff) { minDiff = diff; closest = i; }
    });
    return closest;
  }

  scrollToSlide(i) {
    const slide = this.slides[i];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', () => {
      const i = Math.max(0, this.currentIndex() - 1);
      this.scrollToSlide(i);
    });
    this.nextBtn?.addEventListener('click', () => {
      const i = Math.min(this.slides.length - 1, this.currentIndex() + 1);
      this.scrollToSlide(i);
    });

    let scrollTimeout;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateDots(), 100);
    }, { passive: true });

    // Pause autoplay on hover/focus for accessibility (WCAG 2.2.2)
    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
    this.root.addEventListener('focusin', () => this.stopAutoplay());
    this.root.addEventListener('focusout', () => { if (this.autoplay) this.startAutoplay(); });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      const next = (this.currentIndex() + 1) % this.slides.length;
      this.scrollToSlide(next);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

document.querySelectorAll('.project-slider-wrapper').forEach((el) => new ProjectSlider(el));